import some from 'lodash/some'
import localforage from 'localforage'

const mockInstance = {
  getItem() {
    return Promise.resolve(null)
  },

  setItem() {
    return Promise.resolve(null)
  },

  removeItem() {
    return Promise.resolve(null)
  }
}

const DRIVERS = [localforage.INDEXEDDB, localforage.LOCALSTORAGE, localforage.WEBSQL]

const supported = some(DRIVERS, localforage.supports)

export function createInstance(...args) {
  return supported ? localforage.createInstance(...args) : mockInstance
}
